import { Axios } from "../../Api/axios";
import { clean } from "../Withdrawals/payoutParts";

// Store refunds (Apple App Store Server Notifications v2 / Google RTDN +
// voided-purchases sweep) and the diamond clawbacks they cause — backend
// IapRefundService (Group 1 close-out round 2, 2026-10-22, built in
// parallel with this page; a plain 404 = "not deployed yet").
//
//   GET  Admin-iap-refunds?state=&store=apple|google&q=&page=&limit=
//        → {status, data:[{id, store, transaction_id, user:{id,name,nick_name,img,coins},
//           state, credited_coins, refunded_coins, reason, environment,
//           refunded_at, reversed_at, repeat_refunder}], meta}
//   GET  Admin-diamond-clawbacks?state=flagged|held_clawed|admin_debited|written_off|reversed|all&page=&limit=
//        → {status, data:[{id, state, amount, host:{id,name,nick_name,img,diamonds,diamonds_pending},
//           sender:{id,name}, refund_id, purchase_transaction_id, credit_id, note,
//           created_at, resolved_at, admin_id}], meta, counts}
//   POST Admin-diamond-clawbacks/{id}/debit {note?} | /write-off {note}
//        → {status, changed, data:item}; 409 = the clawback is no longer flagged.
//   GET  Admin-wallet-negative?page= → {status, data:[{id,name,nick_name,img,coins,diamonds,last_refund_at}], meta}
//
// A refunded buyer's coin balance may go below zero (gifts and withdrawals
// blocked, exchange allowed to repay). A host's diamonds still on hold are
// taken back automatically (held_clawed); diamonds already released are
// only FLAGGED here — the admin debits them or writes them off.

export const CLAWBACK_TABS = [
  { key: "flagged", label: "Flagged" },
  { key: "held_clawed", label: "Taken from held" },
  { key: "admin_debited", label: "Debited by admin" },
  { key: "written_off", label: "Written off" },
  /// The store reversed the refund: a held clawback was re-credited, a flag
  /// was cleared (debited / written-off rows keep their state + a note).
  { key: "reversed", label: "Reversed" },
  { key: "all", label: "All" },
];

export const CLAWBACK_BADGE = {
  flagged: { cls: "rv-badge-gold", text: "Flagged" },
  held_clawed: { cls: "rv-badge-violet", text: "Taken from held" },
  admin_debited: { cls: "rv-badge-red", text: "Debited by admin" },
  written_off: { cls: "rv-badge-grey", text: "Written off" },
  reversed: { cls: "rv-badge-green", text: "Reversed" },
};

export const STORES = [
  { key: "apple", label: "App Store" },
  { key: "google", label: "Google Play" },
];

/// Known refund states get a colour; any other state is shown as sent.
export const REFUND_STATE_BADGE = {
  refunded: "rv-badge-red",
  applied: "rv-badge-red",
  partial: "rv-badge-red",
  revoked: "rv-badge-red",
  reversed: "rv-badge-green",
  logged: "rv-badge-grey",
  log_only: "rv-badge-grey",
  pending: "rv-badge-gold",
  pending_credit: "rv-badge-gold",
  pre_credit: "rv-badge-gold",
};

export const listRefunds = (params) => Axios.get("/Admin-iap-refunds", { params: clean(params) }).then((r) => r.data);

export const listClawbacks = (params) =>
  Axios.get("/Admin-diamond-clawbacks", { params: clean(params) }).then((r) => r.data);

export const debitClawback = (id, note) =>
  Axios.post(`/Admin-diamond-clawbacks/${id}/debit`, clean({ note: note?.trim() })).then((r) => r.data);

export const writeOffClawback = (id, note) =>
  Axios.post(`/Admin-diamond-clawbacks/${id}/write-off`, { note: String(note || "").trim() }).then((r) => r.data);

export const listNegative = (params) => Axios.get("/Admin-wallet-negative", { params: clean(params) }).then((r) => r.data);
